import {useEventTracking} from 'src/hooks/useEventTracking';

import {UserAction} from '@pb/kit-component-table-interactions';
import {useCallbackWithRef} from '@pb/kit-util-use-callback-with-ref';


import {TRACKING_COLUMNS} from './constants';

import type {
    OnTrackAddOption,
    OnTrackCheckOption,
    OnTrackClearCell,
    OnTrackCopyPaste,
    OnTrackDeleteOption,
    OnTrackEditValue,
    OnTrackEnableCursor,
    OnTrackSelectCell,
    OnTrackUndo,
    OnTrackUpdateOption,
} from '@pb/kit-component-table-interactions';

export const useValidateColumnsTracking = () => {
    const {userFieldChange} = useEventTracking();

    const onTrackUndo = useCallbackWithRef<OnTrackUndo>(() => undefined);

    const onTrackAddOption = useCallbackWithRef<OnTrackAddOption>(() => undefined);

    const onTrackDeleteOption = useCallbackWithRef<OnTrackDeleteOption>(() => undefined);

    const onTrackCheckOption = useCallbackWithRef<OnTrackCheckOption>(() => undefined);

    const onTrackUpdateOption = useCallbackWithRef<OnTrackUpdateOption>(() => undefined);

    const onTrackSelectCell = useCallbackWithRef<OnTrackSelectCell>(() => undefined);

    const onTrackEnableCursor = useCallbackWithRef<OnTrackEnableCursor>(() => undefined);

    const onTrackEditValue = useCallbackWithRef<OnTrackEditValue>(params => {
        userFieldChange({
            section: 'Validate File',
            parameterName: TRACKING_COLUMNS[params.columnIndex],
            viewType: 'Bulk Import Users',
        });
    });

    const onTrackCopyPaste = useCallbackWithRef<OnTrackCopyPaste>(params => {
        if (params.action === UserAction.PASTE) {
            userFieldChange({
                section: 'Validate File',
                parameterName: TRACKING_COLUMNS[params.columnIndex],
                viewType: 'Bulk Import Users',
            });
        }
    });

    const onTrackClearCell = useCallbackWithRef<OnTrackClearCell>(params => {
        userFieldChange({
            section: 'Validate File',
            parameterName: TRACKING_COLUMNS[params.columnIndex],
            viewType: 'Bulk Import Users',
        });
    });

    return {
        onTrackUndo,
        onTrackUpdateOption,
        onTrackCheckOption,
        onTrackDeleteOption,
        onTrackAddOption,
        onTrackSelectCell,
        onTrackEnableCursor,
        onTrackEditValue,
        onTrackCopyPaste,
        onTrackClearCell,
    };
};
